module.exports = __webpack_public_path__ + "img/16581291_L.1b15632f.png";